import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";

const SESSION_FLAG = "deckscore_grants_ikomatch_exit_shown";

export function GrantsExitIntent() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // grants routes only
    if (!(pathname === "/grants" || pathname.startsWith("/grants/"))) return;
    // never on the extension page (it's an upsell target, not a listing page)
    if (pathname.startsWith("/grants/extension")) return;
    // desktop only
    if (window.matchMedia("(max-width: 767px)").matches) return;

    try {
      if (sessionStorage.getItem(SESSION_FLAG)) return;
    } catch {
      /* ignore */
    }

    const onMouseLeave = (e: MouseEvent) => {
      if (e.clientY > 0) return;
      if ((e.relatedTarget as Node | null) !== null) return;
      // don't show if the extension upsell is currently open
      if (window.__deckscoreExtUpsell?.isOpen()) return;
      try {
        if (sessionStorage.getItem(SESSION_FLAG)) return;
        sessionStorage.setItem(SESSION_FLAG, "1");
      } catch {
        /* ignore */
      }
      setOpen(true);
      document.removeEventListener("mouseout", onMouseLeave);
    };

    document.addEventListener("mouseout", onMouseLeave);
    return () => document.removeEventListener("mouseout", onMouseLeave);
  }, [pathname]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/60 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      onClick={() => setOpen(false)}
    >
      <div
        className="w-full max-w-[440px] rounded-2xl border border-line bg-surface p-7 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="font-script text-accent text-[22px] leading-none">before you go -</p>
        <h2 className="mt-2 font-display text-[24px] font-semibold text-ink">
          Not ready to hunt grants yourself?
        </h2>
        <p className="mt-3 text-[15px] text-ink-secondary leading-relaxed">
          IkoMatch's WhatsApp agent matches you to the right grants and investors - free trial.
        </p>
        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="rounded-full border border-line bg-surface px-4 py-2.5 text-[13.5px] font-medium text-ink-secondary hover:text-ink"
          >
            No thanks
          </button>
          <a
            href="https://ikomatch.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center rounded-full bg-accent px-5 py-2.5 text-[13.5px] font-bold text-accent-ink hover:bg-accent-press"
          >
            Try IkoMatch free →
          </a>
        </div>
      </div>
    </div>
  );
}
